import { render, staticRenderFns } from "./JobOrderEdit.vue?vue&type=template&id=31836c0b&"
import script from "./JobOrderEdit.vue?vue&type=script&lang=js&"
export * from "./JobOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports